document.addEventListener("DOMContentLoaded",cnf_sgs_pd(), false);
document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].addEventListener("click", () => {sgs_next();});
document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].addEventListener("click", () => {sgs_prev();});

function sgs_next(){
  document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
  document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","false");
  var laststep = document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].getAttribute("data-laststep");
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  if(prs_row == "sgs_prd_dry"){rstrdo();}
  if(laststep != "start"){
    var go_next = false;
    var select_value_type = document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_field")[0].getAttribute("class");
    if(select_value_type.indexOf("sgs_prd_sr_field sgs_slct") > -1 ){
      if(document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_inp")[0].value != ""){var go_next = true;};
    }else if(select_value_type.indexOf("sgs_prd_sr_field sgs_chkb") > -1){
      if(document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_chk:checked").length > 0){var go_next = true;};
    };
    if(go_next == true){
      if(document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value == "乾燥機能あり"){
        var Root_LIst = ["sgs_prd_dry","sgs_prd_type","sgs_prd_ppn_A","sgs_prd_frq_A","sgs_prd_quiet_A","sgs_prd_auto_A","sgs_prd_lf_reslt"];
      }else if(document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value == "全自動洗濯機"){
        var Root_LIst = ["sgs_prd_dry","sgs_prd_ppn_B","sgs_prd_frq_B","sgs_prd_quiet_B","sgs_prd_auto_B","sgs_prd_lf_reslt"];
      };
      var prd_exist = chk_slct_inp("mid",Root_LIst,"next");
    }else{
      var prd_exist = false;
    };
    if(go_next == true && prd_exist == true){
      if(laststep == "false"){
        
        var n = Root_LIst.indexOf(prs_row);
        document.getElementById("sgs_prd_lf_reslt").setAttribute("data-disp","true");
        document.getElementById(Root_LIst[n]).setAttribute("data-disp","false");
        document.getElementById(Root_LIst[n + 1]).setAttribute("data-disp","true");
        document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","true");
        document.querySelectorAll(".sgs_prd_sr_snchk")[0].setAttribute("data-snchk_display","true");
        document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_ttl")[0].textContent = (n + 1) + "/" + (Root_LIst.length - 2);
        document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_inner")[0].setAttribute("data-snchk_inner",(n + 1) + "/" + (Root_LIst.length - 2));
        document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_inner")[0].setAttribute("style","width:" + Math.floor(((n + 1) / (Root_LIst.length - 2)) * 100) + "%;transition: width .2s;");
        if(n == Root_LIst.length - 3){
          document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","true");
        }else{
          document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","false");
        };
        document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth" });
      }else if(laststep == "true"){
        document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].setAttribute("data-disp","false");
        document.getElementById("sgs_prd_lf_reslt").setAttribute("data-disp","true");
        document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","start");
        chk_slct_inp("last",Root_LIst,"next");
        document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth" });
      };
    }else if(go_next == true && prd_exist == false){
      document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","true");
    }else{
      document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","true");
    };
  }else{
    window.location.href = "/collections/sgs_prd_was";
  };
};

function sgs_prev(){
  document.querySelectorAll(".sgs_btm_btn_error")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","false");
  document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","false");
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  if(prs_row == "sgs_prd_dry"){
    rstrdo();
  }else{
    if(prs_row != "sgs_prd_lf_reslt"){
      var select_value_type = document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_field")[0].getAttribute("class");
      if(select_value_type.indexOf("sgs_prd_sr_field sgs_slct") > -1 ){
        document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_inp")[0].value = "";
      }else if(select_value_type.indexOf("sgs_prd_sr_field sgs_chkb") > -1){
        if(document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_chk:checked").length > 0){document.getElementById(prs_row).querySelectorAll(".sgs_prd_sr_chk:checked")[0].checked = false;};
      };
    };
    if(document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value == "乾燥機能あり"){
      var Root_LIst = ["sgs_prd_dry","sgs_prd_type","sgs_prd_ppn_A","sgs_prd_frq_A","sgs_prd_quiet_A","sgs_prd_auto_A","sgs_prd_lf_reslt"];
      var Root_dict = {"sgs_prd_dry":"select","sgs_prd_type":"input","sgs_prd_ppn_A":"select","sgs_prd_frq_A":"select","sgs_prd_quiet_A":"input","sgs_prd_auto_A":"input"};
    }else if(document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value == "全自動洗濯機"){
      var Root_LIst = ["sgs_prd_dry","sgs_prd_ppn_B","sgs_prd_frq_B","sgs_prd_quiet_B","sgs_prd_auto_B","sgs_prd_lf_reslt"];
      var Root_dict = {"sgs_prd_dry":"select","sgs_prd_ppn_B":"select","sgs_prd_frq_B":"select","sgs_prd_quiet_B":"input","sgs_prd_auto_B":"input"};
    };
  };
  var n = Root_LIst.indexOf(prs_row);
  document.getElementById(Root_LIst[n]).setAttribute("data-disp","false");
  document.getElementById(Root_LIst[n - 1]).setAttribute("data-disp","true");
  var prvr = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  if(Root_dict[prvr] == "input"){
    var prvr_inp = document.getElementById(prvr).querySelectorAll(".sgs_prd_sr_chk");
    for(var r = 0;r < prvr_inp.length;r++){prvr_inp[r].checked = false;};
  }else{
    document.getElementById(prvr).querySelectorAll(".sgs_prd_sr_inp").value = "";
  };
  var prd_exist = chk_slct_inp("mid",Root_LIst,"prev");
  if(document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].getAttribute("data-laststep") == "start"){
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-sbdisp","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","true");
  }else{
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-sbdisp","true");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","false");
  };  
  if(n - 1 == 0){
    document.querySelectorAll(".sgs_prd_sr_snchk")[0].setAttribute("data-snchk_display","false");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","false");
  }else{
    document.querySelectorAll(".sgs_prd_sr_snchk")[0].setAttribute("data-snchk_display","true");
    document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_ttl")[0].textContent = (n - 1) + "/" + (Root_LIst.length - 2);
    document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_inner")[0].setAttribute("data-snchk_inner",(n - 1) + "/" + (Root_LIst.length - 2));
    document.querySelectorAll(".sgs_prd_sr_snchk .sgs_prd_sr_snchk_inner")[0].setAttribute("style","width:" + Math.floor(((n - 1) / (Root_LIst.length - 2)) * 100) + "%;transition: width .2s;");
    document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","true");
  };
  document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth", block: "start" });
};


function chk_slct_inp(mid_or_last,Root_LIst,np){
  var prd_dt_A = JSON.parse(document.querySelectorAll(".sgs_prd_rsl_pl")[0].getAttribute("data-rsl_pl"));
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  if(np == "next"){
    var prsnt_Root = Root_LIst.slice(0,Root_LIst.indexOf(prs_row) + 1);
    var presentdd = Root_LIst[Root_LIst.indexOf(prs_row) + 1];
  }else{
    var prsnt_Root = Root_LIst.slice(0,Root_LIst.indexOf(prs_row));
    var presentdd = prs_row;
  };
  var filter_list = [];
  for(var a = 0;a < prsnt_Root.length;a++){
    if(prsnt_Root[a] == "sgs_prd_frq_A" || prsnt_Root[a] == "sgs_prd_frq_B"){
      if(prsnt_Root[a] == "sgs_prd_frq_A"){
        var size_list = {"1_A":"6_7","1_B":"6_7","2_A":"6_7","2_B":"7_8","3_A":"7_8","3_B":"8_9","4_A":"8_9","4_B":"9_10","5_A":"9_10","5_B":"10_"};
      }else if(prsnt_Root[a] == "sgs_prd_frq_B"){
        var size_list = {"1_A":"4_5","1_B":"6_7","2_A":"5_6","2_B":"7_8","3_A":"7_8","3_B":"8_9","4_A":"8_9","4_B":"9_10","5_A":"9_10","5_B":"10_"};
      };
      var size_key = document.querySelectorAll("#" + prsnt_Root[a].replace("sgs_prd_frq_","sgs_prd_ppn_") + " .sgs_prd_sr_inp")[0].value + "_" + document.querySelectorAll("#" + prsnt_Root[a] + " .sgs_prd_sr_inp")[0].value;
      var min_s = parseInt(size_list[size_key].split("_")[0]);
      var max_s = parseInt(size_list[size_key].split("_")[1]);
      if(isNaN(max_s)){
        var prd_dt_A = prd_dt_A.filter(prd => prd.size >= min_s);
      }else{
        var prd_dt_A = prd_dt_A.filter(prd => prd.size >= min_s && prd.size <= max_s);
      };
    }else if(prsnt_Root[a] == "sgs_prd_ppn_A" || prsnt_Root[a] == "sgs_prd_ppn_B"){
      if(prsnt_Root[a] == "sgs_prd_ppn_A"){
        var size_list = {"1":"6_7","2":"6_8","3":"7_9","4":"8_10","5":"9_"};
      }else if(prsnt_Root[a] == "sgs_prd_ppn_B"){
        var size_list = {"1":"4_7","2":"5_8","3":"7_9","4":"8_10","5":"9_"};
      };
      var size_key = document.querySelectorAll("#" + prsnt_Root[a] + " .sgs_prd_sr_inp")[0].value;
      var min_s = parseInt(size_list[size_key].split("_")[0]);
      var max_s = parseInt(size_list[size_key].split("_")[1]);
      if(isNaN(max_s)){
        var prd_dt_A = prd_dt_A.filter(prd => prd.size >= min_s);
      }else{
        var prd_dt_A = prd_dt_A.filter(prd => prd.size >= min_s && prd.size <= max_s);
      };
    }else if(prsnt_Root[a] != "sgs_prd_ppn_A" && prsnt_Root[a] != "sgs_prd_ppn_B" && prsnt_Root[a] != "sgs_prd_lf_reslt"){
      var select_value_type = document.getElementById(prsnt_Root[a]).querySelectorAll(".sgs_prd_sr_field")[0].getAttribute("class");
      if(select_value_type.indexOf("sgs_prd_sr_field sgs_slct") > -1){
        var f_value = document.querySelectorAll("#" + prsnt_Root[a] + " .sgs_prd_sr_inp")[0].value;
      }else if(select_value_type.indexOf("sgs_prd_sr_field sgs_chkb") > -1){
        var f_value = document.querySelectorAll("#" + prsnt_Root[a] + " .sgs_prd_sr_chk:checked")[0].getAttribute("data-set_rdo");
      };
      if(f_value != ""){
        filter_list.push(f_value);
      };
    };
  };
  if(filter_list.length > 0){
    var prd_dt_A_flted = prd_dt_A.filter(prd => filter_list.every(tag => prd.spc.includes(tag)));
  }else{
    var prd_dt_A_flted = prd_dt_A;
  };
  if(mid_or_last == "mid"){
    st_elm_box_delt();
    if(prd_dt_A_flted.length == 0){
      var g_nxt = false;
    }else{
      document.querySelectorAll(".sgs_btm_btn_no_next")[0].setAttribute("data-sb_errdisp","false");
      var g_nxt = true;
      if(prd_dt_A_flted.length > 3){
        var midul = midulmk() + "_*_" + np;
        if(size_key == undefined){
          var spcul = "/collections/srt_was_cllc/" + filter_list.join("+") + "?mid_rf_cnfd=" + midul;
        }else{
          var spcul = "/collections/srt_was_cllc/" + filter_list.join("+") + "?mid_rf_szrng=" + min_s + "-" + max_s + "_*_" + size_key + "&mid_rf_cnfd=" + midul;
        };
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href",spcul);
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "すべての検索結果を表示（" + prd_dt_A_flted.length + "件）";
        var prd_dt_A_flted = prd_sgs_moreflt(prd_dt_A_flted);
      }else{
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","display:none;");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "";
      };
      console.log(presentdd);
      if(presentdd != "sgs_prd_dry"){
        document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loading");
        var mrf_prd_dt_A = prd_dt_A_flted.slice(0, 3);
        st_elm_box(mrf_prd_dt_A);
      };
    };
    return g_nxt;
  }else if(mid_or_last == "last"){
    st_elm_box_delt();
    if(prd_dt_A_flted.length > 0){
      
      if(prd_dt_A_flted.length > 7){
        var spcul = "/collections/srt_was_cllc/" + filter_list.join("+") + "?rf_szrng=" + min_s + "-" + max_s + "_*_" + size_key;
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href",spcul);
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "すべての検索結果を表示（" + prd_dt_A_flted.length + "件）";
        var prd_dt_A_flted = prd_sgs_moreflt(prd_dt_A_flted);
      }else{
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("style","display:none;");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].setAttribute("href","");
        document.querySelectorAll(".sgs_prd_rb_saibtm_btn_sprb_D")[0].textContent = "";
      };
      document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loading");
      st_elm_box(prd_dt_A_flted);
    }else{
      document.querySelectorAll(".sgs_btm_btn_noprd")[0].setAttribute("data-sb_errdisp","true");
    };
  };
};



function st_elm_box(srt_data){
  for(var a = 0;a < srt_data.length;a++){
    var sgs_prd_result_box = document.createElement("div");sgs_prd_result_box.setAttribute("class","sgs_prd_result_box");
    var sgs_prd_rb_top = document.createElement("div");sgs_prd_rb_top.setAttribute("class","sgs_prd_rb_top");
    var sgs_prd_rb_head = document.createElement("div");sgs_prd_rb_head.setAttribute("class","sgs_prd_rb_head");
    var sgs_prd_rb_capt = document.createElement("div");sgs_prd_rb_capt.setAttribute("class","sgs_prd_rb_capt");sgs_prd_rb_head.appendChild(sgs_prd_rb_capt);
    var sgs_prd_rb_img = document.createElement("div");sgs_prd_rb_img.setAttribute("class","sgs_prd_rb_img");
    var prd_img = document.createElement("img");prd_img.setAttribute("src","//pandaselections.com/cdn/shop/" + srt_data[a].img);prd_img.setAttribute("width","");prd_img.setAttribute("height","");prd_img.setAttribute("data-sgsimg_ld","loading");sgs_prd_rb_img.appendChild(prd_img);
    var sgs_prd_rb_prc = document.createElement("div");sgs_prd_rb_prc.setAttribute("class","sgs_prd_rb_prc");sgs_prd_rb_prc.textContent = "¥" + parseInt(srt_data[a].prc).toLocaleString() + "～";
    var sgs_prd_rb_ttl = document.createElement("div");sgs_prd_rb_ttl.setAttribute("class","sgs_prd_rb_ttl");sgs_prd_rb_ttl.textContent = srt_data[a].ttl;
    /*var ttl_cnt = srt_data[a].ttl.split("<br>");for(var b = 0;b < ttl_cnt.length;b++){var ttl_cnt_dv = document.createElement("div");ttl_cnt_dv.textContent = ttl_cnt[b];sgs_prd_rb_ttl.appendChild(ttl_cnt_dv);};*/
    var sgs_prd_rb_mkr = document.createElement("div");sgs_prd_rb_mkr.setAttribute("class","sgs_prd_rb_mkr");sgs_prd_rb_mkr.textContent = srt_data[a].mkr;
    var sgs_prd_rb_bottom = document.createElement("div");sgs_prd_rb_bottom.setAttribute("class","sgs_prd_rb_bottom");
    var sprb_U = document.createElement("a");sprb_U.setAttribute("class","sgs_prd_rb_btm_btn sprb_U");
    sprb_U.setAttribute("target","_blank");
    sprb_U.setAttribute("rel","noopener noreferrer")
    sprb_U.setAttribute("href","/products/" + srt_data[a].hndl);
    sprb_U.textContent = "商品の詳細を見る";
    sgs_prd_rb_bottom.appendChild(sprb_U);
    sgs_prd_rb_top.appendChild(sgs_prd_rb_head);
    sgs_prd_rb_top.appendChild(sgs_prd_rb_img);
    sgs_prd_rb_top.appendChild(sgs_prd_rb_prc);
    sgs_prd_rb_top.appendChild(sgs_prd_rb_ttl);
    sgs_prd_rb_top.appendChild(sgs_prd_rb_mkr);
    sgs_prd_result_box.appendChild(sgs_prd_rb_top);
    sgs_prd_result_box.appendChild(sgs_prd_rb_bottom);
    document.querySelectorAll(".sgs_prd_result_box_list")[0].appendChild(sgs_prd_result_box);
    var prd_img_all = document.querySelectorAll(".sgs_prd_result_box_list .sgs_prd_rb_img img");
    var prd_img = prd_img_all[prd_img_all.length - 1];
    if(prd_img.complete){
      prd_img.setAttribute("data-sgsimg_ld","loaded");
    }else{
      prd_img.addEventListener('load', () => {prd_img.setAttribute("data-sgsimg_ld","loaded");img_chkslf(srt_data.length);});
    };
  };
  img_chkslf(srt_data.length);
};


function st_elm_box_delt(){
  var prd_list = document.querySelectorAll(".sgs_prd_result_box_list .sgs_prd_result_box");
  for(var a = prd_list.length - 1;a >= 0;a--){
    prd_list[a].remove();
  };
};



function rstrdo(){
  var chk_elem = document.querySelectorAll(".sgs_prd_main .sgs_prd_sr_chk");
  for(var a = 0;a < chk_elem.length;a++){
    chk_elem[a].checked = false;
  };
};


function img_chkslf(prd_data_length){
  var st_elem = document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_box img");
  if(prd_data_length == st_elem.length){
    var set_disp = true;
    for(var a = 0;a < st_elem.length;a++){
      if(st_elem[a].complete && st_elem[a].getAttribute("src") != ""){
        st_elem[a].setAttribute("data-sgsimg_ld","loaded");
      }else if(st_elem[a].complete && st_elem[a].getAttribute("src") == ""){
        st_elem[a].setAttribute("data-sgsimg_ld","false");
      }else{
        var chk_load = st_elem[a].getAttribute("data-sgsimg_ld");
        if(chk_load == "loading"){
          var set_disp = false;
        };
      };
    };
    if(set_disp == true){
      document.querySelectorAll(".sgs_reslt_match-prd")[0].textContent = "マッチした商品：" + prd_data_length + "件";
      prd_srt_cng();
      document.querySelectorAll(".sgs_prd_result-main .sgs_prd_result_loading_cnt")[0].setAttribute("data-sgs_dlo","loaded");
    };
  };
};


function prd_srt_cng(){
  var cnf_opt = document.querySelectorAll(".sgs_prd_result_box_sort-cnt .sgs_prd_result_box_sort-cnt_slct")[0].value;
  var prnt = document.querySelectorAll(".sgs_prd_result_box_list")[0];
  var prd_list = Array.from(prnt.querySelectorAll(".sgs_prd_result_box"));
  if(cnf_opt == "srt_prd-bill"){
    prd_list.sort((a, b) => {
      const priceA = parseInt(a.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      const priceB = parseInt(b.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      return priceA - priceB;
    });
    prd_list.forEach(prd => prnt.appendChild(prd));
  };
};


function prd_sgs_moreflt(prd_data){
  var grp_list = {};
  prd_data.forEach(prd => {
    var spcK = prd.size + "|" + prd.spc.slice().sort().join('|');
    if (!grp_list[spcK]){grp_list[spcK] = [];};
    grp_list[spcK].push(prd);
  });
  var prd_filtered = [];
  for(var spcK in grp_list) {
    var grp = grp_list[spcK];
    prd_filtered.push(grp[0]);
    /*if(grp.length === 1) {
      prd_filtered.push(grp[0]);
    }else{
      prd_filtered.push(grp[0], grp[grp.length - 1]);
    };*/
  };
  return prd_filtered;
};


function cnf_sgs_pd(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("sgs_pdd");
  var crt_size_base_mid = CRTurl.searchParams.get("sgs_pdd_mid");
  if(crt_size_base != null){
    cnf_sgs_pd_full();
  }else if(crt_size_base_mid != null){
    cnf_sgs_pd_mid();
  };
};

function cnf_sgs_pd_full(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("sgs_pdd");
  data_list = crt_size_base.split("_,_");
  tag_list = data_list[1].split("_*_");
  for(var a=0;a < tag_list.length;a++){
    if(tag_list[a] == "乾燥機能あり"){
      var Root_dict = {"radio":["sgs_prd_type","sgs_prd_quiet_A","sgs_prd_auto_A"],"select":["sgs_prd_ppn_A","sgs_prd_frq_A"]};
      var Root_LIst = ["sgs_prd_dry","sgs_prd_type","sgs_prd_ppn_A","sgs_prd_frq_A","sgs_prd_quiet_A","sgs_prd_auto_A","sgs_prd_lf_reslt"];
      document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value = "乾燥機能あり";
    }else if(tag_list[a] == "全自動洗濯機"){
      var Root_dict = {"radio":["sgs_prd_quiet_B","sgs_prd_auto_B"],"select":["sgs_prd_ppn_B","sgs_prd_frq_B"]};
      var Root_LIst = ["sgs_prd_dry","sgs_prd_ppn_B","sgs_prd_frq_B","sgs_prd_quiet_B","sgs_prd_auto_B","sgs_prd_lf_reslt"];
      document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value = "全自動洗濯機";
    };
  };
  for(var a=0;a < Root_dict["radio"].length;a++){
    if(document.querySelectorAll("#" + Root_dict["radio"][a] + " .sgs_prd_sr_chk[data-set_rdo='']")[0]){
      document.querySelectorAll("#" + Root_dict["radio"][a] + " .sgs_prd_sr_chk[data-set_rdo='']")[0].checked = true;
    };
  };
  for(var a=0;a < tag_list.length;a++){
    for(var b=0;b < Root_dict["radio"].length;b++){
      var each_radio = document.querySelectorAll("#" + Root_dict["radio"][b] + " .sgs_prd_sr_chk[data-set_rdo]");
      for(var c=0;c < each_radio.length;c++){
        if(tag_list[a] != "" && tag_list[a] == each_radio[c].getAttribute("data-set_rdo")){
          each_radio[c].checked = true;
        };
      };
    };
  };
  var size_key = data_list[0].split("_");
  document.querySelectorAll("#" + Root_dict["select"][0] + " .sgs_prd_sr_inp")[0].value = size_key[0];
  document.querySelectorAll("#" + Root_dict["select"][1] + " .sgs_prd_sr_inp")[0].value = size_key[1];
  document.getElementById("sgs_prd_dry").setAttribute("data-disp","false");
  document.getElementById("sgs_prd_lf_reslt").setAttribute("data-disp","true");
  document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_prv")[0].setAttribute("data-sbdisp","true");
  document.querySelectorAll("#sgs_btm_btn_cnt .sgsb_nxt")[0].setAttribute("data-laststep","start");
  chk_slct_inp("last",Root_LIst,"next");
  document.querySelectorAll(".sgs_prd_body")[0].scrollIntoView({ behavior: "smooth" });
};


function cnf_sgs_pd_mid(){
  var CRTurl = new URL(window.location.href);
  var crt_size_base = CRTurl.searchParams.get("sgs_pdd_mid");
  var Root_dict = {"sgs_prd_dry":"select","sgs_prd_type":"radio","sgs_prd_quiet_A":"radio","sgs_prd_auto_A":"radio","sgs_prd_ppn_A":"select","sgs_prd_frq_A":"select","sgs_prd_quiet_B":"radio","sgs_prd_auto_B":"radio","sgs_prd_ppn_B":"select","sgs_prd_frq_B":"select"};
  var data_list = crt_size_base.split("_*_")[0].split("*");
  if(crt_size_base.split("_*_")[1] == "next"){
    var last_ind = data_list.length
  }else{
    var last_ind = data_list.length - 1;
  };
  for(var a=0;a < last_ind;a++){
    var tg = data_list[a].split(",");
    if(Root_dict[tg[0]] == "radio"){
      document.querySelectorAll("#" + tg[0] + " .sgs_prd_sr_chk")[parseInt(tg[1])].checked = true;
    }else if(Root_dict[tg[0]] == "select"){
      document.querySelectorAll("#" + tg[0] + " .sgs_prd_sr_inp")[0].value = tg[1];
    };
  };
  document.getElementById("sgs_prd_dry").setAttribute("data-disp","false");
  document.getElementById(tg[0]).setAttribute("data-disp","true");
  sgs_next();
};


document.querySelectorAll(".sgs_prd_result_box_sort-cnt .sgs_prd_result_box_sort-cnt_slct")[0].addEventListener("change", (event) => {
  prd_srt_cng();
});

function prd_srt_cng(){
  var cnf_opt = document.querySelectorAll(".sgs_prd_result_box_sort-cnt .sgs_prd_result_box_sort-cnt_slct")[0].value;
  var prnt = document.querySelectorAll(".sgs_prd_result_box_list")[0];
  var prd_list = Array.from(prnt.querySelectorAll(".sgs_prd_result_box"));
  if(cnf_opt == "srt_prd-bill"){
    prd_list.sort((a, b) => {
      const priceA = parseInt(a.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      const priceB = parseInt(b.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      return priceA - priceB;
    });
    prd_list.forEach(prd => prnt.appendChild(prd));
    
  }else if(cnf_opt == "srt_prd-size_small"){
    prd_list.sort((a, b) => {
      const priceA = parseInt(a.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      const priceB = parseInt(b.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      return priceA - priceB;
    });
    prd_list.sort((a, b) => {
      const priceA = parseInt(a.querySelector('.sgs_prd_rb_ttl').textContent.split(" (洗濯・脱水")[1].split("kg")[0]);
      const priceB = parseInt(b.querySelector('.sgs_prd_rb_ttl').textContent.split(" (洗濯・脱水")[1].split("kg")[0]);
      return priceA - priceB;
    });
    prd_list.forEach(prd => prnt.appendChild(prd));
    
  }else if(cnf_opt == "srt_prd-size_big"){
    prd_list.sort((a, b) => {
      const priceA = parseInt(a.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      const priceB = parseInt(b.querySelector('.sgs_prd_rb_prc').textContent.replace("¥","").replace(",","").replace("～",""));
      return priceA - priceB;
    });
    prd_list.sort((a, b) => {
      const priceA = parseInt(a.querySelector('.sgs_prd_rb_ttl').textContent.split(" (洗濯・脱水")[1].split("kg")[0]);
      const priceB = parseInt(b.querySelector('.sgs_prd_rb_ttl').textContent.split(" (洗濯・脱水")[1].split("kg")[0]);
      return priceB - priceA;
    });
    prd_list.forEach(prd => prnt.appendChild(prd));
  };
};

function midulmk(){
  var rtd = [];
  var Root_dict = {"sgs_prd_dry":"select","sgs_prd_type":"radio","sgs_prd_quiet_A":"radio","sgs_prd_auto_A":"radio","sgs_prd_ppn_A":"select","sgs_prd_frq_A":"select","sgs_prd_quiet_B":"radio","sgs_prd_auto_B":"radio","sgs_prd_ppn_B":"select","sgs_prd_frq_B":"select"};
  var prs_row = document.querySelectorAll(".sgs_prd_section-row[data-disp='true']")[0].getAttribute("id");
  var f_tag = document.querySelectorAll("#sgs_prd_dry .sgs_prd_sr_inp")[0].value;
  if(f_tag == "乾燥機能あり"){
    var Root_LIst = ["sgs_prd_dry","sgs_prd_type","sgs_prd_ppn_A","sgs_prd_frq_A","sgs_prd_quiet_A","sgs_prd_auto_A","sgs_prd_lf_reslt"];
  }else if(f_tag == "全自動洗濯機"){
    var Root_LIst = ["sgs_prd_dry","sgs_prd_ppn_B","sgs_prd_frq_B","sgs_prd_quiet_B","sgs_prd_auto_B","sgs_prd_lf_reslt"];
  };
  var n = Root_LIst.indexOf(prs_row);
  var next_row = Root_LIst[n + 1];
  for(var a = 0;a < Root_LIst.length;a++){
    if(Root_dict[Root_LIst[a]] == "radio"){
      if(document.querySelectorAll("#" + Root_LIst[a] + " .sgs_prd_sr_chk:checked").length > 0){
        var slct_data = [...document.querySelectorAll("#" + Root_LIst[a] + " .sgs_prd_sr_chk")].indexOf(document.querySelectorAll("#" + Root_LIst[a] + " .sgs_prd_sr_chk:checked")[0]);
        rtd.push(Root_LIst[a] + "," + slct_data);
      };
    }else if(Root_dict[Root_LIst[a]] == "select"){
      if(document.querySelectorAll("#" + Root_LIst[a] + " .sgs_prd_sr_inp")[0].value != undefined && document.querySelectorAll("#" + Root_LIst[a] + " .sgs_prd_sr_inp")[0].value != ""){
        var slct_data = document.querySelectorAll("#" + Root_LIst[a] + " .sgs_prd_sr_inp")[0].value;
        rtd.push(Root_LIst[a] + "," + slct_data);
      };
    };
    if(Root_LIst[a] == next_row){
      break;
    };
  };
  return rtd.join("*");
};